// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1wEE8","rootSmall":"AddTileButton_rootSmall__2fzFf"};